import { type PropsWithChildren, useMemo } from 'react';

import { useLookerModelId } from '@/hooks/looker/use-looker-model-id';
import { useMe } from '@/hooks/use-me';
import { useLookerSdk } from '@/hooks/useLookerSdk';
import { DummyWarrantyRepository } from '@/warranty/infra/repositories/dummy/dummy.warranty.repository';
import { LookerWarrantyRepository } from '@/warranty/infra/repositories/looker/looker.warranty.repository';
import {
  type Dependencies,
  DependenciesProvider,
} from '@/warranty/view/contexts/dependencies.context';

type LookerProviderProps = PropsWithChildren<{}>;

export function LookerProvider({ children }: LookerProviderProps) {
  const me = useMe();
  const coreSDK = useLookerSdk();
  const lookerModel = useLookerModelId();
  const dependencies = useMemo<Dependencies>(
    function () {
      return {
        repositories: {
          warranty:
            me.config.id === '49' /* demo_bess */
              ? new DummyWarrantyRepository()
              : new LookerWarrantyRepository(coreSDK, lookerModel),
        },
      };
    },
    [coreSDK, lookerModel, me.config.id],
  );

  return (
    <DependenciesProvider dependencies={dependencies}>
      {children}
    </DependenciesProvider>
  );
}
